import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Page from '@zg-rentals/multibrand-ui/lib/Page';
import PageNotFound from '@zg-rentals/multibrand-ui/lib/PageNotFound';

const NotFoundPage = ({ brand }) => (
  // since this app is using an old version of multibrand-ui, do not remove the `hideFooter`
  // prop as that will load legacy onetrust/optanon logic. Also the footer styles and text
  // are very outdated, example "Copyright 2017"
  <Page noPadding className="NotFoundPage" hideFooter>
    <PageNotFound brand={brand} />
  </Page>
);

NotFoundPage.propTypes = {
  brand: PropTypes.string,
};

export default connect((state) => ({
  brand: state.app.brand,
}))(NotFoundPage);
